import React, { useContext } from 'react'
import { DocsideCmsContext } from 'src/supportPortal/context/DocsideCmsContextProvider'
import { useNavigate, useParams } from 'react-router-dom'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import { Alert, Box, Button, CircularProgress } from '@mui/material'
import ProductSelection from 'src/supportPortal/views/docSide/components/ProductSelection'

export default function DocSideContexts() {
  const { productPackageId } = useParams()
  const navigate = useNavigate()

  const { contexts, products, loadingContexts, errorContexts, loadContexts } =
    useContext(DocsideCmsContext)

  const handleContextSelect = (context) => {
    navigate(`/support-home/doc-side/${productPackageId}/contexts/${context.id}/roles`)
  }

  const selectedProduct = products.find((p) => p.id === productPackageId)

  return (
    <div className="d-flex flex-column h-100">
      <SupportHeader
        heading={selectedProduct?.title || 'Product'}
        subHeading="Select Context"
        showBackButton
      />

      <Box
        sx={{
          flex: 1,
          p: { xs: 2, sm: 3, md: 4 },
          maxWidth: '1400px',
          width: '100%',
          margin: '0 auto',
          background: 'linear-gradient(180deg, rgba(249, 250, 251, 0.5) 0%, rgba(243, 244, 246, 0.3) 100%)',
          minHeight: 'calc(100vh - 80px)',
        }}
      >
        {/* Global Error Alert */}
        {errorContexts && (
          <Alert
            severity="error"
            sx={{
              mb: 3,
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
            action={
              <Button
                size="small"
                onClick={() => {
                  loadContexts()
                }}
                sx={{ textTransform: 'none' }}
              >
                Retry
              </Button>
            }
          >
            {errorContexts}
          </Alert>
        )}

        {/* Loading State */}
        {loadingContexts && (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '400px',
            }}
          >
            <CircularProgress />
          </Box>
        )}

        {!loadingContexts && !errorContexts && (
          <ProductSelection
            products={contexts?.filter((c) => c.productAppId === productPackageId)}
            onProductSelect={handleContextSelect}
            title="Select a Context"
            description="Choose a context to manage its documentation and help content"
          />
        )}
      </Box>
    </div>
  )
}
